<div class="dialog-title">Contact List</div>

<div class="dialog-search">
  <mat-icon>search</mat-icon>
  <input
    type="text"
    class="form-control"
    placeholder="Search here ..."
    name="searchText"
    autofocus
    #searchInput
    [(ngModel)]="value"
  />
</div>

<div class="scroll-dialog-content core-list">
  <mat-list>
    <mat-list-item
      *ngFor="let lead of contactList | SearchFilter: value; ; let i=index"
    >
      <div fxLayout="row wrap" class="align-item-center">
        <mat-radio-group [(ngModel)]="selected">
          <mat-radio-button [value]="lead?.phoneNo"></mat-radio-button>
        </mat-radio-group>
        <div fxFlex>
          <div class="xsTitle-f" matLine>{{lead?.fullName}}</div>
          <div class="contact-row" mat-line>
            <span class="icon-text">
              <mat-icon class="indicator-12">stay_current_portrait</mat-icon>
              <span class="fs-10">{{lead?.phoneNo}}</span>
            </span>
            <span class="vertical-divider desc-f"> | </span>
            <span class="icon-text">
              <mat-icon class="indicator-12">email</mat-icon>
              <span class="fs-10">{{lead?.email}}</span>
            </span>
          </div>
        </div>
      </div>
    </mat-list-item>
  </mat-list>
</div>

<div class="dialog-buttons">
  <button mat-button color="primary" [mat-dialog-close]="false">Cancel</button>
  <button
    mat-button
    color="primary"
    [mat-dialog-close]="false"
    (click)="submit()"
  >
    Send
  </button>
</div>
